(function () {
  // New Address Form Validation
  const newAddressFormState = {
    allFilled: false,
    allValid: false,
  };

  const editAddressFormState = {
    allFilled: false,
    allValid: false,
  };

  function updateSubmitNewBtnState(button) {
    if (newAddressFormState.allFilled && newAddressFormState.allValid) {
      button.disabled = false;
      button.classList.remove("disabled");
    } else {
      button.disabled = true;
      button.classList.add("disabled");
    }
  }

  function updateSubmitEditBtnState(button) {
    if (editAddressFormState.allFilled) {
      button.disabled = false;
      button.classList.remove("disabled");
    } else {
      button.disabled = true;
      button.classList.add("disabled");
    }
  }

  function newFormCheckRequiredFields(fields, errorContainer, button) {
    let allFilled = true;

    fields.forEach((field) => {
      if (field.value.trim() === "") {
        allFilled = false;
      }
    });

    if (!allFilled) {
      errorContainer.innerHTML = "Please fill out all required (*) fields.";
    } else {
      errorContainer.innerHTML = "";
    }

    newAddressFormState.allFilled = allFilled;
    updateSubmitNewBtnState(button);
  }

  function editFormCheckRequiredFields(fields, errorContainer, button) {
    let allFilled = true;

    fields.forEach((field) => {
      if (field.value.trim() === "") {
        allFilled = false;
      }
    });

    if (!allFilled) {
      errorContainer.innerHTML = "Please fill out all required (*) fields.";
    } else {
      errorContainer.innerHTML = "";
    }

    editAddressFormState.allFilled = allFilled;
    updateSubmitEditBtnState(button);
  }

  function setupAddressValidation(fields, errors, button, formState, updateButtonState) {
    const letters = /^[A-Za-z0-9 ]+$/;

    fields.forEach((field, index) => {
      const value = field.value;
      const isValueValid = value.match(letters) || value === "";

      if (!isValueValid) {
        field.style.borderColor = "red";
        errors[index].innerHTML =
          "Please use only English characters and numbers.";
      }

      field.addEventListener("input", (e) => {
        const inputValue = field.value;
        const isInputValid = inputValue.match(letters) || inputValue === "";

        if (isInputValid) {
          field.style.borderColor = "lightgray";
          errors[index].innerHTML = "";
        } else {
          field.style.borderColor = "red";
          errors[index].innerHTML =
            "Please use only English characters and numbers.";
        }

        const hasInvalidField = Array.from(fields).some(
          (f) => !(f.value.match(letters) || f.value === "")
        );

        formState.allValid = !hasInvalidField;
        updateButtonState(button);
      });

      // Add event listener to reset invalid inputs on clicking outside the modal
      document.addEventListener("click", (event) => {
        if (!event.target.closest(".modal__container")) {
          fields.forEach((field, index) => {
            if (field.style.borderColor === "red") {
              errors[index].innerHTML = "";
              field.style.borderColor = "lightgray";
              field.value = ""; // Reset the input value to empty
            }
          });
        }
      });
    });
  }

  function newFormValidationInit() {
    const submitNewBtn = document.querySelector("[data-new-submit]");
    const requiredFields = document.querySelectorAll("#new-address-form [data-form-required]");
    const addressNewFields = document.querySelectorAll(
      "#new-address-form [data-add-first-address-new], #new-address-form [data-add-second-address-new]"
    );
    const requiredFieldErrorContainer = document.querySelector(
      "#new-address-form #required-fields-error"
    );
    const addressNewErrors = document.querySelectorAll(
      "#new-address-form [first_new_address_error], #new-address-form [second_new_address_error]"
    );

    requiredFields.forEach((field) => {
      field.addEventListener("input", () => {
        newFormCheckRequiredFields(
          requiredFields,
          requiredFieldErrorContainer,
          submitNewBtn
        );
      });
    });

    newFormCheckRequiredFields(
      requiredFields,
      requiredFieldErrorContainer,
      submitNewBtn
    );
    setupAddressValidation(addressNewFields, addressNewErrors, submitNewBtn, newAddressFormState, updateSubmitNewBtnState);
  }

  newFormValidationInit();

  function editFormValidationInit() {
    const submitEditBtns = document.querySelectorAll("[data-edit-submit]");

    submitEditBtns.forEach((submitEditBtn) => {
        const form = submitEditBtn.closest("form");
        const requiredFields = form.querySelectorAll("[data-form-required]");
        const addressEditFields = form.querySelectorAll(
            "[data-add-first-address-edit], [data-add-second-address-edit]"
        );
        const requiredFieldErrorContainer = form.querySelector("#required-fields-error");
        const addressEditErrors = form.querySelectorAll("[first_edit_address_error], [second_edit_address_error]");

        requiredFields.forEach((field) => {
            field.addEventListener("input", () => {
                editFormCheckRequiredFields(
                    requiredFields,
                    requiredFieldErrorContainer,
                    submitEditBtn
                );
            });
        });

        editFormCheckRequiredFields(
            requiredFields,
            requiredFieldErrorContainer,
            submitEditBtn
        );

      setupAddressValidation(addressEditFields, addressEditErrors, submitEditBtn, editAddressFormState[form], updateSubmitEditBtnState);
    });
}

function editFormCheckRequiredFields(requiredFields, errorContainer, button) {
    let allFilled = true;

    requiredFields.forEach((field) => {
        if (field.value.trim() === "") {
            allFilled = false;
        }
    });

    if (!allFilled) {
        errorContainer.innerHTML = "Please fill out all required (*) fields.";
        button.disabled = true; 
    } else {
        errorContainer.innerHTML = ""; 
        button.disabled = false; 
    }
}



editFormValidationInit();


  // Minimum birthdate is 18 years old
  $(function () {
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    const maxDateISO = maxDate.toISOString().split("T")[0];
    $("#profile-date_of_birth-input").attr("max", maxDateISO);

    $("#profile-date_of_birth-input").on("change", function () {
      const inputDate = new Date($(this).val());
      if (inputDate > maxDate) {
        $("#date_error").html("You must be at least 18 years old.");
      } else {
        $("#date_error").html("");
      }
    });
  });

  // Remove HTML form validation and leave to only JS validation
  const form = document.querySelector("#new-address-form");
  const formEdit = document.querySelector("#edit-address-form");
  if (form) {
    form.setAttribute("novalidate", true);
  }
  if (formEdit) {
    formEdit.setAttribute("novalidate", true);
  }
})();